import { DataDisplayEvent, DataSource, DataSourceExecutionEvent, DataSourceMode, Label, Panel, Textbox } from "@mcleod/components";
import { AutogenLayoutTableStopsUnauthenticated } from "./autogen/AutogenLayoutTableStopsUnauthenticated";
import { ModelRow } from "@mcleod/core";
import { ImageName } from "@mcleod/images";

export class TableStopsUnauthenticated extends AutogenLayoutTableStopsUnauthenticated {

    private stops: []; 

    /** This is an event handler for the onDataDisplay event of labelStopNumber.  */
    labelStopNumberOnDataDisplay(event: DataDisplayEvent) {
        const status = event.rowData.get("status");
        const statusLabel = (event.target as Label)
        if (status != null && status == "D") {
            statusLabel.text = null;
            statusLabel.padding = 0;
            statusLabel.imageName = ImageName.circleCheck;
            statusLabel.imageColor = "primary";
            statusLabel.imageWidth = 27;
            statusLabel.borderWidth = 0;

        }
        else if (event.rowData.get("actual_arrival") != null && event.rowData.get("actual_departure") == null) {
            statusLabel.backgroundColor = "primary";
            statusLabel.color = "primary.reverse"
        }
    }

    /** This is an event handler for the afterExecution event of sourceCustomerOrderDetail.  */
    sourceCustomerOrderDetailUnauthenticated(event: DataSourceExecutionEvent) {
        const row = event.dataSource.activeRow as ModelRow;
        this.tableStops.dataSource = new DataSource();
        this.stops = row.get("stops");
        this.populateDataSource(this.stops, this.tableStops.dataSource);
    }

    /** This is an event handler for the onDataDisplay event of textboxSchedArriveEarly.  */
    textboxSchedArriveEarlyOnDataDisplay(event: DataDisplayEvent) {
        const late = event.rowData.get("sched_arrive_late");
        if (late != null) {
            (event.target as Textbox).caption = "Scheduled to arrive between";
        }
    }

    /** This is an event handler for the onDataDisplay event of panelLine.  */
    panelLineOnDataDisplay(event: DataDisplayEvent) {
        if (this.stops != null && event.rowData.get("order_sequence") == this.stops.length) {
            (event.target as Panel).visible = false;
        }
    }

    private populateDataSource(data: [], dataSource: DataSource) {
        dataSource.setRowsAndMode(DataSourceMode.NONE, data?.map(data => new ModelRow(dataSource.url, false, data)) ?? []);
    }
}
